"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var e = require("@babel/runtime/helpers/classCallCheck"),
    t = require("@babel/runtime/helpers/createClass"),
    r = require("@babel/runtime/helpers/inherits"),
    n = require("@babel/runtime/helpers/possibleConstructorReturn"),
    a = require("@babel/runtime/helpers/getPrototypeOf"),
    l = require("@babel/runtime/helpers/slicedToArray"),
    o = require("@babel/runtime/helpers/objectWithoutProperties");

function i(e) {
  return e && "object" == typeof e && "default" in e ? e : {
    default: e
  };
}

var s = i(e),
    u = i(t),
    c = i(r),
    f = i(n),
    h = i(a),
    v = i(l),
    d = i(o),
    m = function m(e) {
  return "string" == typeof e;
},
    _ = function _(e) {
  return "function" == typeof e;
},
    g = new Map(),
    y = new Map();

function p(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
      r = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2];
  return function (n) {
    if (m(n) && (n = new Date(n)), r) {
      var a = D(e, t),
          l = y.get(a);
      if (l) return l.format(n);
      var o = new Intl.DateTimeFormat(e, t);
      return y.set(a, o), o.format(n);
    }

    var i = new Intl.DateTimeFormat(e, t);
    return i.format(n);
  };
}

function b(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
      r = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2];
  return function (n) {
    if (r) {
      var a = D(e, t),
          l = g.get(a);
      if (l) return l.format(n);
      var o = new Intl.NumberFormat(e, t);
      return g.set(a, o), o.format(n);
    }

    var i = new Intl.NumberFormat(e, t);
    return i.format(n);
  };
}

function D(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
      r = Array.isArray(e) ? e.sort().join("-") : e;
  return "".concat(r, "-").concat(JSON.stringify(t));
}

var k = Object.freeze({
  __proto__: null,
  date: p,
  number: b
}),
    A = /\\u[a-fA-F0-9]{4}|\\x[a-fA-F0-9]{2}/g;

function O(e) {
  var t = e.locale,
      r = e.locales,
      n = e.values,
      a = e.formats,
      l = e.localeData,
      o = function (e, t) {
    var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {
      plurals: void 0
    },
        n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {};
    t = t || e;

    var a = r.plurals,
        l = function l(e) {
      return m(e) ? n[e] || {
        style: e
      } : e;
    },
        o = function o(e, r) {
      return function (n) {
        var a = _(r) ? r(n) : r,
            l = Array.isArray(a) ? a : [a],
            o = b(t)(e);
        return l.map(function (e) {
          return m(e) ? e.replace("#", o) : e;
        });
      };
    };

    return a || console.error("Plurals for locale ".concat(e, " aren't loaded. Use i18n.loadLocaleData method to load plurals for specific locale. Using other plural rule as a fallback.")), {
      plural: function plural(e, t) {
        var r = t.offset,
            n = void 0 === r ? 0 : r,
            l = d.default(t, ["offset"]),
            i = l[e] || l[null == a ? void 0 : a(e - n)] || l.other;
        return o(e - n, i);
      },
      selectordinal: function selectordinal(e, t) {
        var r = t.offset,
            n = void 0 === r ? 0 : r,
            l = d.default(t, ["offset"]),
            i = l[e] || l[null == a ? void 0 : a(e - n, !0)] || l.other;
        return o(e - n, i);
      },
      select: function select(e, t) {
        return t[e] || t.other;
      },
      number: function number(e, r) {
        return b(t, l(r))(e);
      },
      date: function date(e, r) {
        return p(t, l(r))(e);
      },
      undefined: function undefined(e) {
        return e;
      }
    };
  }(t, r, l, a);

  return function e(t, r, a) {
    var l = n[t],
        i = o[r](l, a),
        s = _(i) ? i(e) : i;
    return Array.isArray(s) ? s.join("") : s;
  };
}

function j(e, t, r, n) {
  return function (a) {
    var l = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
        o = O({
      locale: t,
      locales: r,
      localeData: n,
      formats: l,
      values: a
    }),
        i = function e(t) {
      return Array.isArray(t) ? t.reduce(function (t, r) {
        if (m(r)) return t + r;
        var n = v.default(r, 3),
            a = n[0],
            l = n[1],
            i = n[2],
            s = {};
        null == i || m(i) ? s = i : Object.keys(i).forEach(function (t) {
          s[t] = e(i[t]);
        });
        var u = o(a, l, s);
        return null == u ? t : t + u;
      }, "") : t;
    },
        s = i(e);

    return m(s) && A.test(s) ? JSON.parse('"'.concat(s.trim(), '"')) : m(s) ? s.trim() : s;
  };
}

var x = function () {
  function e() {
    s.default(this, e), this._events = {};
  }

  return u.default(e, [{
    key: "on",
    value: function value(e, t) {
      var r = this;
      return this._hasEvent(e) || (this._events[e] = []), this._events[e].push(t), function () {
        return r.removeListener(e, t);
      };
    }
  }, {
    key: "removeListener",
    value: function value(e, t) {
      if (this._hasEvent(e)) {
        var r = this._events[e].indexOf(t);

        ~r && this._events[e].splice(r, 1);
      }
    }
  }, {
    key: "emit",
    value: function value(e) {
      for (var t = this, r = arguments.length, n = new Array(r > 1 ? r - 1 : 0), a = 1; a < r; a++) {
        n[a - 1] = arguments[a];
      }

      this._hasEvent(e) && this._events[e].map(function (e) {
        return e.apply(t, n);
      });
    }
  }, {
    key: "_hasEvent",
    value: function value(e) {
      return Array.isArray(this._events[e]);
    }
  }]), e;
}();

function w(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;

    try {
      return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();

  return function () {
    var r,
        n = h.default(e);

    if (t) {
      var a = h.default(this).constructor;
      r = Reflect.construct(n, arguments, a);
    } else r = n.apply(this, arguments);

    return f.default(this, r);
  };
}

var L = function (e) {
  c.default(r, e);
  var t = w(r);

  function r(e) {
    var n;
    return s.default(this, r), n = t.call(this), n._messages = {}, n._localeData = {}, null != e.missing && (n._missing = e.missing), null != e.messages && n.load(e.messages), null != e.localeData && n.loadLocaleData(e.localeData), null == e.locale && null == e.locales || n.activate(e.locale, e.locales), n;
  }

  return u.default(r, [{
    key: "_loadLocaleData",
    value: function value(e, t) {
      null == this._localeData[e] ? this._localeData[e] = t : Object.assign(this._localeData[e], t);
    }
  }, {
    key: "loadLocaleData",
    value: function value(e, t) {
      var r = this;
      null != t ? this._loadLocaleData(e, t) : Object.keys(e).forEach(function (t) {
        return r._loadLocaleData(t, e[t]);
      }), this.emit("change");
    }
  }, {
    key: "_load",
    value: function value(e, t) {
      null == this._messages[e] ? this._messages[e] = t : Object.assign(this._messages[e], t);
    }
  }, {
    key: "load",
    value: function value(e, t) {
      var r = this;
      null != t ? this._load(e, t) : Object.keys(e).forEach(function (t) {
        return r._load(t, e[t]);
      }), this.emit("change");
    }
  }, {
    key: "activate",
    value: function value(e, t) {
      this._locale = e, this._locales = t, this.emit("change");
    }
  }, {
    key: "_",
    value: function value(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
          n = r.message,
          a = r.formats,
          l = r.context;
      m(e) || (t = e.values || t, n = e.message, l = e.context, e = e.id);
      var o,
          i = !l && !this.messages[e],
          s = l && !this.messages[l][e],
          u = s || i,
          c = this._missing;
      return c && u ? _(c) ? c(this._locale, e, l) : c : (u && this.emit("missing", {
        id: e,
        context: l,
        locale: this._locale
      }), o = l && !s ? this.messages[l][e] || n || e : this.messages[e] || n || e, m(o) && A.test(o) ? JSON.parse('"'.concat(o, '"')) : m(o) ? o : j(o, this._locale, this._locales, this.localeData)(t, a));
    }
  }, {
    key: "date",
    value: function value(e, t) {
      return p(this._locales || this._locale, t)(e);
    }
  }, {
    key: "number",
    value: function value(e, t) {
      return b(this._locales || this._locale, t)(e);
    }
  }, {
    key: "locale",
    get: function get() {
      return this._locale;
    }
  }, {
    key: "locales",
    get: function get() {
      return this._locales;
    }
  }, {
    key: "messages",
    get: function get() {
      var e;
      return null !== (e = this._messages[this._locale]) && void 0 !== e ? e : {};
    }
  }, {
    key: "localeData",
    get: function get() {
      var e;
      return null !== (e = this._localeData[this._locale]) && void 0 !== e ? e : {};
    }
  }]), r;
}(x);

function q() {
  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
  return new L(e);
}

var E = q();
exports.I18n = L, exports.formats = k, exports.i18n = E, exports.setupI18n = q;